import styled from 'styled-components';
import { Common, device } from '@stockbit/ui';

const { Flex } = Common;

export const ResearchBox = styled(Flex)`
  align-items: flex-start;
  border-bottom: solid 1px #f1f1f1;
  cursor: pointer;
  gap: 16px;
  justify-content: space-between;
  margin: 0 20px;

  &:last-child {
    border-bottom: none;
  }
`;

export const ResearchImage = styled.div`
  background: #f7f7f7;
  border-radius: 4px;
  height: 75px;
  position: relative;
  width: 100px;

  img {
    border-radius: 4px;
    height: 100%;
    object-fit: cover;
    object-position: center top;
    opacity: 1;
    position: absolute;
    width: 100%;
  }

  @media ${device.tablet} {
    height: 90px;
    width: 120px;
  }
`;
